import type { RouteResponse } from '@/api/main/types.gen'
import type { RouteId } from './types'

export function pickDefaultActiveRoute(activeRoutes: RouteResponse[], planningAreaId: string): RouteId | undefined {
  const inArea = activeRoutes
    .filter(route => route.planning_area_id === planningAreaId)
    .sort((a, b) => a.id.localeCompare(b.id))
  const first = inArea[0]
  return first ? { id: first.id, version: first.version } : undefined
}
